import React, { useMemo, useRef } from 'react';
import { trackButtonActivity } from 'src/functions/propagateQueryParams';
import getButtonStyleByColorScheme, { ColorScheme } from 'src/styles/functions/getButtonStyleByColorScheme';
import { StyledButtonPrimaryProps, StyledButtonPrimary, StyledCaptionSpan } from './Button.primary.styles';

export interface IButtonPrimaryProps extends StyledButtonPrimaryProps {
  onClick?: (e?: any) => void;
  text: string;
  caption?: string;
  color?: string;
  padding?: string;
  id?: string;
  type?: 'button' | 'submit';
  colorScheme?: ColorScheme;
  disabled?: boolean;
  width?: string;
}

// TODO: Refactor Button component functions onto generic component generator
//  that uses a dynamic wrapper element and is reused by all the existing buttons
const ButtonPrimary = ({
  onClick,
  text,
  caption,
  justify,
  weight,
  color,
  padding,
  width,
  id,
  type,
  colorScheme,
  disabled = false,
}: IButtonPrimaryProps): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>();
  const buttonColors = useMemo(() => getButtonStyleByColorScheme(colorScheme, 'primary'), []);

  // Extend onClick listener for Trackers, etc.
  const trackOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(e);
    }
    // >> Additional trackers
    trackButtonActivity(buttonRef.current, text);
  };

  return (
    <StyledButtonPrimary
      className='styled-button-primary'
      ref={buttonRef}
      onClick={trackOnClick}
      justify={justify}
      weight={weight}
      width={width}
      color={color ?? buttonColors.backgroundColor}
      textColor={buttonColors.textColor}
      id={id}
      type={type}
      padding={padding}
      disabled={disabled}
    >
      <span>{text}</span>
      {caption ? <StyledCaptionSpan>{caption}</StyledCaptionSpan> : null}
    </StyledButtonPrimary>
  );
};

export default ButtonPrimary;
